import { STORE_GROUP_SEARCH } from './action_types';

const search = payload => ({
  type: STORE_GROUP_SEARCH,
  payload: payload
});

export { search };
